/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface UserAccountDetailsRequest
 */
export interface UserAccountDetailsRequest {
    /**
     * Non Active users will have any webhooks/scheduled reports removed. Closed accounts cannot be reopened.
     * @type {string}
     * @memberof UserAccountDetailsRequest
     */
    accountStatus?: UserAccountDetailsRequestAccountStatusEnum;
    /**
     * Only for Drivers. Enterprise and End users get their name from AD/ADB2C.
     * @type {string}
     * @memberof UserAccountDetailsRequest
     */
    name?: string;
    /**
     * Only for Drivers. Enterprise and End users get their email from AD/ADB2C. Username is not changed.
     * @type {string}
     * @memberof UserAccountDetailsRequest
     */
    email?: string;
    /**
     * Only for Drivers. Not required or used for other user types.
     * @type {string}
     * @memberof UserAccountDetailsRequest
     */
    mobileNo?: string;
}

/**
 * @export
 */
export const UserAccountDetailsRequestAccountStatusEnum = {
    Invited: "Invited",
    Pending: "Pending",
    Active: "Active",
    Suspended: "Suspended",
    Closed: "Closed",
} as const;
export type UserAccountDetailsRequestAccountStatusEnum =
    (typeof UserAccountDetailsRequestAccountStatusEnum)[keyof typeof UserAccountDetailsRequestAccountStatusEnum];

/**
 * Check if a given object implements the UserAccountDetailsRequest interface.
 */
export function instanceOfUserAccountDetailsRequest(
    value: object,
): value is UserAccountDetailsRequest {
    return true;
}

export function UserAccountDetailsRequestFromJSON(
    json: any,
): UserAccountDetailsRequest {
    return UserAccountDetailsRequestFromJSONTyped(json, false);
}

export function UserAccountDetailsRequestFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): UserAccountDetailsRequest {
    if (json == null) {
        return json;
    }
    return {
        accountStatus:
            json["accountStatus"] == null ? undefined : json["accountStatus"],
        name: json["name"] == null ? undefined : json["name"],
        email: json["email"] == null ? undefined : json["email"],
        mobileNo: json["mobileNo"] == null ? undefined : json["mobileNo"],
    };
}

export function UserAccountDetailsRequestToJSON(
    value?: UserAccountDetailsRequest | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        accountStatus: value["accountStatus"],
        name: value["name"],
        email: value["email"],
        mobileNo: value["mobileNo"],
    };
}
